<script setup>
import {computed, onMounted, ref, watch} from "vue";
import store from "@/store";
import {couponConf} from "@/utils/config";
import {useRoute} from "vue-router";
import axiosApi from "@/utils/axiosApi";
import LoginComponents from "@/components/login/LoginComponents.vue";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import RealName from "@/components/login/RealName.vue";
import {ElMessage} from "element-plus";
import router from "@/router";

const types = computed(() => {
  return couponConf.sqwl
})
const loading = ref(false)
const showPayLoading = ref(false)
const number = ref(1)

const route = useRoute()
const coupon = ref({})
const showLogin = ref(false)
const account = computed(() => store.state.account)
const href = window.location.href
const order_from = computed(()=>store.state.orderFrom)
watch(account, (to) => {
  if (!to.cust_id) {
    showLogin.value = true
  }
})
onMounted(async () => {
  store.commit("getCoupon")
  store.commit("getOrderFrom")
  await store.dispatch("getAccounts")
  getCoupon()
})

const maxNumber = computed(() => {
  let balanceMiles = parseFloat(account.value?.balance_miles || 0)
  let couponMiles = parseFloat(coupon.value?.score_data?.scal?.discount || 0)
  console.log(balanceMiles, couponMiles)
  if (couponMiles < balanceMiles) {
    return Math.floor(balanceMiles / couponMiles)
  } else {
    return 1
  }
})

const total_miles = computed(() => {
  return number.value * coupon.value?.score_data?.scal?.discount
})

const getCoupon = () => {
  showLogin.value = false
  new axiosApi({
    encode: 'site',
    method: "coupon/cat_coupon_detail",
    body: {
      cid: route.params.id
    }
  }).send(res => {
    if (res.message.code === "000") {
      res.data.detail = res.data.detail.filter(v => v.key.length && v.value.length)
      coupon.value = res.data
      let details = {}
      coupon.value.detail.forEach(v => {
        details[v.key] = v.value
      })
      coupon.value.detail = details
      document.title = coupon.value.name
    }
  })
}
const sendSms = ref(false)
const realname = ref(false)
const mobile = ref("")
const payment = () => {
  if (!account.value?.cust_id) {
    showPayLoading.value = false
    showLogin.value = true
    return;
  }
  if (!mobile.value || !/^1[2-9]\d{9}$/.test(mobile.value)) {
    return ElMessage.error("请输入手机号")
  }
  if (!sendSms.value) {
    sendSms.value = true
    return;
  }
  sendSms.value = false
  loading.value = true
  new axiosApi({
    encode: 'site',
    method: "coupon/pay",
    body: {
      coupon_id: coupon.value.id,
      uid: account.value.uid,
      pay_type: "scal",
      pay_params: JSON.stringify({
        cust_id: account.value.cust_id
      }),
      number: number.value,
      auto_coupon: "1",
      mobile: mobile.value,
      order_from: order_from.value
    }
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    } else if (res.message.code === "7041") {
      realname.value = true
      return
    }
    router.replace({name: 'home', query: {order: res.data.ordersn}})
  }, () => loading.value = false)
}
</script>

<template>
  <el-scrollbar class="page-pid page-detail" :style="types.style" v-if="Object.keys(coupon).length">
    <div class="coupon-images" v-html="coupon.remark" v-if="route.query.contents === 'ticket' || !route.query.contents">
    </div>
    <div class="coupon-images" v-else>
      <el-image :src="coupon.detail?.contents"/>
    </div>
  </el-scrollbar>
  <el-empty v-else/>
  <div class="footer" v-if="Object.keys(coupon).length">
    <div class="kefu">
      <!--      <p>-->
      <!--        <i class="ticket-font ticket-kefu"></i>-->
      <!--      </p>-->
      <!--      <p>联系客服</p>-->
    </div>
    <div class="money"><span class="miles">{{ coupon?.score_data?.scal?.discount }}</span>{{
        coupon?.score_data?.scal?.unit
      }}
    </div>
    <div class="btn">
      <el-button round type="primary" size="large" color="#E12020" v-if="Object.keys(account).length"
                 :disabled="parseFloat(account.balance_miles) < parseFloat(coupon?.score_data?.scal?.discount)"
                 @click="showPayLoading=true">
        立即兑换
      </el-button>
      <el-button round type="primary" size="large" color="#E12020" v-else @click="showLogin=true">
        请登录
      </el-button>
    </div>
  </div>
  <login-components :show-login="showLogin" v-if="showLogin" @login="getCoupon"/>
  <el-drawer v-model="showPayLoading" direction="btt" class="pay-box" size="590">
    <template #header>
      <div class="header">
        <div class="header-logo">
          <el-image :src="coupon?.images"/>
        </div>
        <div class="header-title">
          <h4>{{ coupon?.name }}<span v-if="coupon.title">({{ coupon.title }})</span></h4>
          <!--          <div class="jingle">原价{{ // parseFloat(coupon?.face_value) }}元{{ coupon.name }}</div>-->
          <div class="pay-miles">
            <span class="pay-miles-value">{{ coupon?.score_data?.scal?.discount }}</span>{{
              coupon?.score_data?.scal?.unit
            }}
          </div>
        </div>
      </div>
    </template>
    <div class="tips">
      兑换成功后，激活码将以短信的形式发放至下方填写的手机号，因手机号填写错误造成的损失由会员本人承担。
    </div>
    <el-card class="cards">
      <div class="pay-numbers">
        <div class="pay-numbers-label">填写手机号</div>
        <div class="pay-number-value">
          <el-input v-model="mobile" placeholder="请输入接收激活码的手机号"/>
        </div>
      </div>
    </el-card>
    <el-card class="cards">
      <div class="pay-numbers">
        <div class="pay-numbers-label">兑换数量</div>
        <div class="pay-number-value">
          <el-input-number v-model="number" :max="maxNumber" :min="1"/>
        </div>
      </div>
    </el-card>
    <el-card class="cards">
      <div class="pay-numbers">
        <div class="pay-numbers-label">可用{{ coupon?.score_data?.scal.unit }}</div>
        <div class="pay-number-value">
          {{ account?.balance_miles }}
        </div>
      </div>
      <div class="pay-numbers">
        <div class="pay-numbers-label">支付{{ coupon?.score_data?.scal.unit }}</div>
        <div class="pay-number-value">
          {{ total_miles }}
        </div>
      </div>
    </el-card>
    <div class="btn">
      <el-button round type="danger" color="#E31D1A" :loading="loading" size="large"
                 :disabled="total_miles > account.balance_miles" @click="payment">立即兑换
      </el-button>
    </div>
  </el-drawer>
  <send-sms-components v-if="sendSms" :show="sendSms" @sends="payment" :login-account="account"/>
  <real-name :dialog="realname" v-if="realname" :href="href"/>
</template>

<style scoped lang="less">
.page-detail {
  height: calc(100vh - 64px);
  background: var(--theme-color);
  box-sizing: border-box;

  .coupon-img {
    margin-bottom: 15px;
    padding: 15px 15px 0;
  }

  .coupon-titles {
    border-radius: 12px;
    line-height: 1.75;
    margin: 15px;

    .coupon-details {
      //margin: 15px 0;
      list-style: none;
      line-height: 1.75;
      font-size: .85rem;
      padding: 10px;
      background: var(--theme-color);
      border-radius: 8px;

      .coupon-details-info {
        display: flex;

        .coupon-details-label {
          white-space: nowrap;
        }
      }
    }
  }

  .divider {
    width: 180px;
    margin: 20px auto;
    border-top: 1px solid #999;
    position: relative;

    &:before {
      position: absolute;
      content: "图文详情";
      background: var(--theme-color);
      top: -10px;
      width: 5em;
      text-align: center;
      margin-left: -2.5em;
      left: 50%;
      font-size: .8rem;
      color: #999;
    }
  }

  /deep/ .coupon-images {
    width: 100%;
    overflow: hidden;
    //padding: 0 15px 15px;
    box-sizing: border-box;

    img {
      width: 100vw;
    }
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 15px;
  background: #ffffff;
  box-shadow: var(--el-box-shadow);

  .kefu {
    color: #E31D1A;
    text-align: center;
    font-size: .8rem;

    .ticket-font {
      font-size: 20px;
    }
  }

  .money{
    margin-right: 25px;
  }

  .miles {
    color: #E31D1A;
  }
}

.pay-box {
  .header {
    display: flex;
    line-height: 1.75;

    .header-logo {
      flex-basis: 100px;
      width: 100px;
      //background: #dedede;
      border-radius: 12px;
      margin-right: 10px;
      text-align: center;
      overflow: hidden;

      .el-image {
        width: 100%;
        margin: auto;
        text-align: center;
      }
    }

    .jingle {
      color: #999;
      font-size: .8rem;
    }

    .pay-miles {
      .pay-miles-value {
        color: #E31D1A;
        font-size: 1.75rem;
      }
    }
  }

  .tips {
    color: #999;
    font-size: .8rem;
    line-height: 1.75;
    margin-bottom: 15px;

    .required {
      color: #E31D1A;
    }
  }

  .cards {
    margin-bottom: 15px;
    border-radius: 12px;

    .pay-numbers {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;

      & + .pay-numbers {
        //margin-top: 15px;
        border-top: var(--el-border);
      }
    }
  }

  .btn {
    text-align: center;

    .el-button {
      width: 90%;
      margin: auto;
    }
  }
}
</style>
